import {Injectable} from "@angular/core";
//import { FileBlob } from "./fileBlob.model";

import {AuthenticationService} from './index';
import {LoginHelper} from "../helpers";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class UploadService {

    constructor(public http: HttpClient,
                public authenticationService: AuthenticationService,
                public config: IndexConfigService) { }

  @Load()
  uploadControlItems(entity: File, complianceAreaName: string/*, complianceAreaId: string*/) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, complianceAreaName);

    return this.http
      .post<any>(this.config.api + '/api/controlitems/upload', formData)
      ;
  }

  @Load()
  uploadControlItemsHierarchy(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/controlitems/upload/hierarchy', formData)
      ;
  }
  @Load()
  uploadControlItemsBroadcast(entity: File) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity);

    return this.http
      .post<any>(this.config.api + '/api/controlitems/upload/broadcast', formData)
      ;
  }
}
